export enum HospitalType {
  Hospital = "standard",
  Clinic = "clinic",
  Any = "any",
}
